"use client";

import React from "react";
import { motion, AnimatePresence } from "motion/react";
import { AlertCircle } from "lucide-react";
import type { FormFieldProps } from "@/types/contact";

export function FormField({
  id,
  label,
  required = false,
  error,
  children,
  className = "",
}: FormFieldProps) {
  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      <label
        htmlFor={id}
        className="text-xs font-bold uppercase tracking-widest"
        style={{ color: "#C5A880" }}
      >
        {label}
        {required && (
          <span
            className="ml-1 text-sm"
            style={{ color: "#C5A880" }}
            aria-hidden="true"
          >
            *
          </span>
        )}
      </label>

      {children}

      <AnimatePresence mode="wait">
        {error && (
          <motion.div
            key={`error-${id}`}
            initial={{ opacity: 0, y: -6, height: 0 }}
            animate={{ opacity: 1, y: 0, height: "auto" }}
            exit={{ opacity: 0, y: -6, height: 0 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="flex items-center gap-1.5 mt-0.5"
            role="alert"
            aria-live="polite"
          >
            <AlertCircle
              className="shrink-0"
              size={13}
              style={{ color: "#ef4444" }}
              aria-hidden="true"
            />
            <span
              className="text-xs font-medium"
              style={{ color: "#ef4444" }}
              id={`${id}-error`}
            >
              {error}
            </span>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}